import { Navbar } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledNavbar = styled(Navbar)`
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
  padding: 8px 10px;
  .active {
    color: rgb(37, 114, 188) !important;
    font-weight: 500;
  }
  .navbar-brand {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
`;

export const Title = styled.span`
  color: rgb(37, 114, 188);
  font-size: 13px;
  margin: 0;
  display: block;
  line-height: 1.4;
  color: #007bff;
`;
export const SubTitle = styled.span`
  color: rgb(225, 42, 42);
  margin: 0;
  font-size: 0.9rem;
  display: block;
`;
export const Logo = styled.img`
  width: 65px;
  height: auto;
  display: flex;
  align-items: center;
`;

export const UserDropDown = styled.div`
  display: flex;
  padding-right: 10px;
  align-items: center;
  #dropdown-basic {
    background-color: transparent;
    color: #0a53be;
  }
  .dropdown .btn-primary:hover,
  .dropdown .btn-primary:focus,
  .dropdown .btn-primary:active {
    transform: none;
    opacity: 1;
  }
`;
